import { render, staticRenderFns } from "./department-code.vue?vue&type=template&id=434b0c01&"
import script from "./department-code.vue?vue&type=script&lang=js&"
export * from "./department-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports